import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ServiceCall } from '../modules/ComponentsLibrary/ServiceCall';

export const Route = createFileRoute('/jobs-admin/$jobId')({
  component: RouteComponent,
  params: z.object({
    jobId: z.coerce
      .number()
      .min(0)
      .refine((val) => !isNaN(val), {
        message: 'Job ID must be a valid number',
      }),
  }),
  validateSearch: z.object({
    defaultTab: z.coerce.number().min(0).optional().default(0),
  }),
  head(ctx) {
    return {
      meta: [{ title: `Job Admin View - ${ctx.params.jobId}` }],
    };
  },
});

function RouteComponent() {
  const { jobId } = Route.useParams();
  const { defaultTab } = Route.useSearch();

  return <ServiceCall serviceCallId={jobId} defaultTab={defaultTab} />;
}
